<div class="banner" fxLayout="row" fxLayoutAlign="center center">
    <img [src]="this.bannerImageSrc" alt="Econocom OneCare banner"/>
  </div>